import styled from 'styled-components';

const Card = styled.div`
  background: #fff;
  border: 2px solid #e0e6ed;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);

  padding: 50px 20px;
  height: 400px;
  width: 100%;
`;

export default Card;